import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { RfpClientOneLayoutSkeleton } from '@/components/modules/pages/rfp/client/Layout/RfpClientOneLayout/RfpClientOneLayoutSkeleton';
import { RfpMessageListSkeleton } from '@/components/modules/pages/rfp/client/List/RfpMessageList/RfpMessageListSkeleton';
// TODO: Layout を storybook 管理できるようになったら RfpClientOneNegotiateViewSkeleton と合わせる
export const RfpClientOneNegotiateViewSkeletonInner = () => (_jsx(RfpClientOneLayoutSkeleton, { children: _jsx(RfpMessageListSkeleton, {}) }));
